import React from 'react';

const RejectionModal = ({ 
  isOpen, 
  onClose, 
  adminNotes, 
  onNotesChange, 
  onConfirm, 
  actionLoading 
}) => {
  if (!isOpen) return null;

  const rejectionReasons = [
    'Does not meet marketplace guidelines',
    'Inappropriate content',
    'Suspected scam/fraud',
    'Poor quality images',
    'Incomplete information',
    'Price manipulation',
    'Duplicate listing',
    'Violates terms of service'
  ];

  const handleReasonClick = (reason) => {
    onNotesChange(reason);
  };

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-xl border border-gray-700 w-full max-w-md shadow-2xl">
        <div className="p-6 border-b border-gray-700">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-red-900/30 rounded-lg border border-red-700/30">
                <span className="text-red-400 text-xl">❌</span>
              </div>
              <div>
                <h3 className="text-lg font-bold text-white">Reject Listing</h3>
                <p className="text-gray-400 text-sm mt-1">
                  Provide a reason for rejection. This will be visible to the seller.
                </p>
              </div>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-300 p-1.5 rounded-full hover:bg-gray-700 transition-colors"
            >
              ✕
            </button>
          </div>
        </div>

        <div className="p-6">
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-3">
                Quick Reasons
              </label>
              <div className="grid grid-cols-2 gap-2">
                {rejectionReasons.map((reason, index) => (
                  <button
                    key={index}
                    onClick={() => handleReasonClick(reason)}
                    className={`p-3 text-left rounded-lg border text-sm transition-all duration-200 ${
                      adminNotes === reason
                        ? 'border-red-500/50 bg-red-900/20 text-red-300'
                        : 'border-gray-600 bg-gray-750 hover:border-red-500/30 hover:bg-gray-700 text-gray-300'
                    }`}
                  >
                    {reason}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-300 mb-3">
                Custom Reason
              </label>
              <textarea
                value={adminNotes}
                onChange={(e) => onNotesChange(e.target.value)}
                placeholder="Or write your own reason..."
                className="w-full p-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:ring-2 focus:ring-red-500 focus:border-transparent transition-all"
                rows="4"
              />
              <div className="flex items-center justify-between mt-2">
                <p className="text-xs text-gray-500">
                  Minimum 10 characters required.
                </p>
                <p className={`text-xs ${
                  adminNotes?.length >= 10 ? 'text-green-400' : 'text-gray-500'
                }`}>
                  {adminNotes?.length || 0}/10
                </p>
              </div>
            </div>

            <div className="bg-red-900/20 border border-red-700/30 rounded-lg p-4">
              <div className="flex items-start gap-3">
                <span className="text-red-400">⚠️</span>
                <div>
                  <div className="font-semibold text-red-300">Important</div>
                  <p className="text-sm text-red-400 mt-1">
                    Rejecting this listing will notify the seller and make the listing inactive.
                  </p>
                </div>
              </div>
            </div>

            <div className="flex gap-3 pt-4">
              <button
                onClick={onClose}
                disabled={actionLoading}
                className="flex-1 px-4 py-3 border border-gray-600 text-gray-300 rounded-lg font-medium hover:bg-gray-700 hover:text-white hover:border-gray-500 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                disabled={!adminNotes?.trim() || adminNotes.length < 10 || actionLoading}
                className="flex-1 px-4 py-3 bg-gradient-to-r from-red-600 to-red-500 text-white rounded-lg font-semibold hover:from-red-700 hover:to-red-600 transition-all duration-200 hover:scale-[1.02] shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
              >
                {actionLoading ? (
                  <div className="flex items-center justify-center gap-2">
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Rejecting...</span>
                  </div>
                ) : (
                  'Reject Listing'
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RejectionModal;